import { useMemo } from 'react';

import { PowerUsersPanel } from '../components/PowerUsersPanel';
import { useGeneralAccountSection } from '../hooks/useGeneralAccountInfo';
import { useMembers } from '../hooks/useMembers';
import type { Account, Member } from '../model';
import { RECENTLY_ACTIVE_MEMBERS_URL } from '../namedContacts/constants';
import { getRecentlyActiveMembers } from '../namedContacts/getRecentlyActiveMembers';

type Props = {
  account: Account;
};

export function PowerUsersPanelContainer({ account }: Props) {
  const membersQuery = useMembers(account, {
    paginated: true,
    url: RECENTLY_ACTIVE_MEMBERS_URL,
  });
  const frequentContactsQuery = useGeneralAccountSection(account, 'frequentContacts');

  const recentlyActive = useMemo(() => {
    const entities = membersQuery.data?.entities?.members;
    const members: Member[] = entities ? (Object.values(entities) as Member[]) : [];
    return getRecentlyActiveMembers(members);
  }, [membersQuery.data]);

  return (
    <PowerUsersPanel
      recentlyActive={recentlyActive}
      isLoadingRecentlyActive={membersQuery.isLoading}
      recentlyActiveError={membersQuery.error ? new Error(String(membersQuery.error)) : null}
      frequentContacts={frequentContactsQuery.data?.frequentContacts}
      isLoadingFrequentContacts={frequentContactsQuery.isLoading}
      frequentContactsError={frequentContactsQuery.error ? new Error(String(frequentContactsQuery.error)) : null}
    />
  );
}
